import request from '@webtrader/core/request';

import { EOptionSymbolSide, ESymbolType, IHorizonSymbolTickRulesGroup } from '../market/symbols';
import { EOrderState, EOrderType } from '../order';
import { ETradeFillPolicyValue } from '../trade';
import { EHorizonExecuteType, EHorizonOrderStatus, ENotificationTemplate } from './constants';
import { ENotificationSettingsType } from './settings';

export enum ERejectOrderRequestType {
  ORDER_CANCEL_REQUEST = 'ORDER_CANCEL_REQUEST',
  ORDER_CANCEL_REPLACE_REQUEST = 'ORDER_CANCEL_REPLACE_REQUEST'
}

export enum ENotificationType {
  ORDER = 'ORDER',
  SYSTEM = 'SYSTEM',
  INFORMATION = 'INFORMATION'
}

export enum ENotificationOrderStateCentroid {
  NEW = 'NEW',
  PARTIALLY_FILLED = 'PARTIALLY_FILLED',
  FILLED = 'FILLED',
  CLOSED = 'CLOSED',
  MODIFIED = 'MODIFIED',
  REJECTED = 'REJECTED',
  CANCELED = 'CANCELED'
}

export interface INotificationMetadata {
  symbol?: string;
  eventId?: string;
  eventDate?: number;
  hasExpired?: boolean;

  avgFilledPrice: number;
  closePrice: number;
  cmd: EOrderType; // cmd - OrderType
  comment: string;
  expireTime: number;
  lotSize: number;
  filledLotSize: number;
  remainedLotSize: number;
  metatraderId: number;
  openPrice: number;
  openTime: number;
  orderId: string;
  orderState: EOrderState;
  price: number; // Limit Price
  profit: number;
  stopLoss: number;
  stopPrice: number;
  takeProfit: number;
  volume: number;
  symbolType: ESymbolType;

  // Centroid
  centroidNotificationOrderState: ENotificationOrderStateCentroid;
  centroidTimeInForce: ETradeFillPolicyValue;
  centroidSymbolDecimal: number;

  // Horizon Only
  tradeId: number; // tradeId - NOT IN USE
  symbolSide: EOptionSymbolSide;
  type: number;
  horizonExecuteType: EHorizonExecuteType;
  horizonOrderStatus: EHorizonOrderStatus;
  horizonTimeInForce: ETradeFillPolicyValue;
  tickRulesGroup: IHorizonSymbolTickRulesGroup[];
  origClOrdId: string; // Original order ID. When an order is edited, a new order ID replaces the old one, and this field stores the previous order ID.
}

export interface INotification {
  id: string;
  read: boolean;
  title: string;
  created: number;
  message: string;
  orderId: string | null;
  metadata: INotificationMetadata;
  description: string;
  publishDate: number;
  settingType: ENotificationSettingsType;
  url?: string;
  notificationTemplate: ENotificationTemplate;
  sequenceNo: number | null;
}

export interface INotificationParams {
  notificationType: ENotificationType;
}

const notification = (params: INotificationParams) => {
  return request.get<INotification[]>('/api/notification/v2', {
    params
  });
};

export default notification;
